import { FormInput, type FormInputProps } from "@prismicio/editor-ui"

import {
  RequestFormInputBase,
  type RequestFormInputBaseProps,
} from "./RequestFormInputBase"

export type RequestFormInputProps = Pick<RequestFormInputBaseProps, "label"> &
  FormInputProps

export function RequestFormInput(props: RequestFormInputProps) {
  const { label, ...formInputProps } = props

  return (
    <RequestFormInputBase label={label}>
      <FormInput {...formInputProps} size="medium" />
    </RequestFormInputBase>
  )
}
